import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { MAILING_SETTINGS_API } from '../api/mailing-settings-api'

export const useSubstituteEmails = () => {
  const { fetcher } = useFetch<RequestMethodsEnum.get, Record<string, string> | []>({
    method: RequestMethodsEnum.get,
  })

  const { data } = useControlledSwr(
    [`${MAILING_SETTINGS_API}/substitute-email`, RequestModuleEnum.UserEmail],
    fetcher,
  )

  // https://systeme-team.slack.com/archives/C074L362C2C/p1761654667029509?thread_ts=1761317551.346699&cid=C074L362C2C
  return { substituteEmails: Array.isArray(data) ? {} : data }
}
